export enum BtnTypeColor {
    none = 'transparent',
    primary = '#449bd1', // $ce1
    second = '#ef5086', // $ce2
    third = '#fea724', // $ce3
    warn = '#ffac11',
    success = '#009688',
    error = '#f44336'
}
